import { generateLocalizedRouteConfig, LocalizedRoutes } from '@/router/localizedRouting';
import { CREATE_PROPERTY_FROM_INSERTION_ON_DEMAND_PATH } from '@/router/routes/constants';
import { Pages } from '@/types';
import { RouteRecordRaw } from 'vue-router';

const routes: LocalizedRoutes = {
  de: {
    path: CREATE_PROPERTY_FROM_INSERTION_ON_DEMAND_PATH['de'],
    meta: { requiresAuth: true, scrollToTop: true },
  },
  en: {
    path: CREATE_PROPERTY_FROM_INSERTION_ON_DEMAND_PATH['en'],
    meta: { requiresAuth: true, scrollToTop: true },
  },
  fr: {
    path: CREATE_PROPERTY_FROM_INSERTION_ON_DEMAND_PATH['fr'],
    meta: { requiresAuth: true, scrollToTop: true },
  },
  it: {
    path: CREATE_PROPERTY_FROM_INSERTION_ON_DEMAND_PATH['it'],
    meta: { requiresAuth: true, scrollToTop: true },
  },
};

const Component = () =>
  import('@/pages/CreatePropertyFromInsertionOnDemandPage/CreatePropertyFromInsertionOnDemandPage.vue');

const localizedRouteConfig = (): RouteRecordRaw[] =>
  generateLocalizedRouteConfig(routes, Component, Pages.CreatePropertyFromInsertionOnDemand);

export default localizedRouteConfig;
